import emailjs from 'emailjs-com';
import { API_BASE } from '../lib/apiBase';

/**
 * Lead submission — every public form on the site goes through here so the
 * pipeline (EmailJS, already configured for the homepage enquiry form) stays in
 * one place. Extra fields are flattened into the template payload.
 */
const SERVICE_ID = 'service_bad7mo7';
const TEMPLATE_ID = 'template_959b86d';
const PUBLIC_KEY = 'gX6EjQHilFXYsqv1b';

export type LeadPayload = {
  /** Which form sent it, e.g. "contact", "book-painter", "sample-request". */
  source: string;
  name: string;
  mobile?: string;
  email?: string;
  pincode?: string;
  message?: string;
  [key: string]: string | number | boolean | undefined;
};

export async function submitLead(payload: LeadPayload): Promise<{ ok: true } | { ok: false; error: string }> {
  const data: Record<string, unknown> = {
    ...payload,
    // Compose a readable summary so the email template always has something useful
    // even when it only prints a fixed set of fields.
    message: [payload.message, ...Object.entries(payload).filter(([k]) => !['name', 'mobile', 'email', 'pincode', 'message', 'source'].includes(k)).map(([k, v]) => `${k}: ${String(v)}`)]
      .filter(Boolean)
      .join('\n'),
    submittedAt: new Date().toISOString(),
    page: typeof window !== 'undefined' ? window.location.pathname : '',
  };
  // Save to the admin's enquiries inbox and send the notification email in
  // parallel; the visitor sees success if either one gets through.
  const saved = fetch(`${API_BASE}/api/enquiries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, page: data.page }),
  }).then((r) => r.ok);
  const emailed = emailjs.send(SERVICE_ID, TEMPLATE_ID, data, PUBLIC_KEY).then(() => true);
  const [db, mail] = await Promise.allSettled([saved, emailed]);
  if ((db.status === 'fulfilled' && db.value) || mail.status === 'fulfilled') return { ok: true };
  // eslint-disable-next-line no-console
  console.error('[leads] submit failed', db, mail);
  return { ok: false, error: 'Something went wrong while sending your request. Please try again, or email support@vertexpaint.com.' };
}

export const isValidIndianMobile = (v: string) => /^(\+91[\s-]?)?[6-9]\d{9}$/.test(v.replace(/\s/g, ''));
export const isValidPincode = (v: string) => /^[1-9]\d{5}$/.test(v.trim());
export const isValidEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
